import classNames from 'classnames';
import React, { CSSProperties, ElementType, ReactNode } from 'react';
import { Styled } from '../types';

const fontFamilies = {
  primary: 'font-display',
  primary_light: 'font-display',
  primary_bold: 'font-display font-bold',
  secondary: 'font-body',
  secondary_light: 'font-body',
  secondary_bold: 'font-body font-bold'
};

const fontSizes: { [key: string]: string } = {
  tiny: 'text-xs',
  small: 'text-xs',
  small_read: 'text-xs',
  smallread: 'text-xs',
  medium: 'text-sm',
  mini: '',
  normal: '',
  xnormal: 'text-2xl',
  big: 'text-3xl',
  large: 'text-4xl',
  xlarge: 'text-5xl'
};

type TextProps = Styled &
  CSSProperties & {
    children: ReactNode;
    family?:
      | 'primary'
      | 'primary_light'
      | 'primary_bold'
      | 'secondary'
      | 'secondary_light'
      | 'secondary_bold';
    fontSize?:
      | 'tiny'
      | 'small'
      | 'smallread'
      | 'small_read'
      | 'mini'
      | 'medium'
      | 'normal'
      | 'xnormal'
      | 'big'
      | 'large'
      | 'xlarge'
      | string
      | number;
    text?: string;
    as?: ElementType;
  };

const Text = ({
  children,
  family = 'secondary',
  fontSize = 'small_read',
  text = '',
  className = '',
  as: Comp = 'p',
  style = {},
  ...restProps
}: TextProps) => (
  <Comp
    style={{
      ...style,
      ...restProps,
      ...(fontSize && !fontSizes[fontSize] ? { fontSize } : {})
    }}
    className={classNames(
      fontFamilies[family],
      fontSizes[fontSize],
      className,
      'whitespace-pre-wrap'
    )}
  >
    {text || children}
  </Comp>
);

export default Text;
